import Navs from '../Component/navs';
import Home from '../pages/Home';
import Service from '../pages/services';
import Friendly from './sectionprovide';
import '../style/landing.css';
import Skils from './sectionsils';
import Plans from './plans';
import Feedback from './feedback';
import Contact from './contactus';
import Footer from './footer';
import SEO from "../Component/SEO.js"

export default function Landingpage() {
  return (
    <>
     <SEO
        title="lamar-reinigung"
        description="Lamar Reinigungsservice bietet Industriereinigung, Büroreinigung, Glasreinigung und umweltfreundliche Reinigungsdienste in Karlsruhe."
        keywords="Reinigungsservice Karlsruhe, Gebäudereinigung, Büroreinigung, Industriereinigung, Fensterreinigung"
        url="https://lamar-f7165.web.app/"
        image="https://lamar-reinigung.de/logo.png"
      />
      <Home ></Home>
      <Service ></Service>
      <Friendly></Friendly>
      <Skils></Skils>
      <Plans></Plans>
      <Feedback></Feedback>
      <Contact></Contact>
      <Footer></Footer>
    </>
  );
}
